import { j as o } from "../../jsx-runtime-p91LotPX.mjs";
import "../../GrowAvatar-DJSlhesM.mjs";
import "../Button/style.js";
import "../CheckBox/style.js";
import "../Typography/AntTypography.js";
import "../utils/datetime-formatter.js";
import "../../core.esm-D9FG3ApV.mjs";
import "../../SortableItem-C--6XTJo.mjs";
import "../../lodash-lyheMOjd.mjs";
import "react";
import "../Dnd/SortableContainer.js";
import "../../style-ClHoikNh.mjs";
import "../../AntDrawer-ChgesM8B.mjs";
import "../../style-BCs5tvAM.mjs";
import "../StatusTag/style.js";
import "../../main-C3-4ZYQP.mjs";
import "../../index.es-YI5dIElQ.mjs";
import "../Table/ColumnCustom/ColumnSort/ColumnSortList.js";
import "../../table-XsUAem3c.mjs";
import "../../style-pk1ekFUy.mjs";
import "../Table/BulkAction/style.js";
import "../Table/Pagination/style.js";
import "../Table/style.js";
import "../Tree/style.js";
import "../UI/FormArea/FormFooter.js";
import "../css.js";
import { themeConfig as i } from "../../theme/theme.js";
import { C as t } from "../../index-CjjiqU7h.mjs";
function B(r) {
  return /* @__PURE__ */ o.jsx(t, { theme: i, children: r.children });
}
export {
  B as default
};
//# sourceMappingURL=ThemeProvider.js.map
